export default {
  header : [
    {
      title : '+ 项目概览',
      children : [
        {
          title: '2017 首届中华青少年交响乐团',
          to: '/2017-inaugural-season'
        },
        {
          title: '2018 室内乐系列',
          to: '/2018-chamber-series'
        }
      ]
    },
    {
      title : '媒体报道',
      to : '/press-media/',
    },
    {
      title : '关于我们',
      to : '/about/',
    },
    {
      isLanguageToggle: true,
      title : 'Eng',

    },
  ],
  'home_page' : {
    'backgrounds' : [
      {
        src: "/img/home/2017-inaugural-season.jpg",
        href: "/2017-inaugural-season",
        name: "2017 首届中华青少年交响乐团",
      },
      {
        src: "/img/home/2018-chamber-series.jpg",
        href: "/2018-chamber-series",
        name: "2018 室内乐系列",
      }
    ]
  },
  'about_page' : {

    overview : {
      title : '关于 NYO-China',
      imgSrc : '/img/about/entering_carnegie.jpg',
      description : [
        {
          'text':'中华青少年交响乐团（NYO-China）是由约100名14至21岁的中国音乐家组成的青少年管弦乐团。在完成两周封闭式训练后，乐团成员将登上美国卡内基音乐厅进行首演；随后，他们将在世界各地进行巡演。NYO-China旨在通过提供珍贵的学习和演出机会，将中国青少年音乐家培养成为世界舞台上展示中国风采的艺术使者。',
          'containsHTML': 'false',
        },
        {
          'text':'2016年NYO-China成立，2017年夏首届音乐训练营及全球巡演正式启动。乐团首演由卡内基音乐厅官方呈现，这是该音乐厅126年历史上第一次官方呈现来自中国的青少年交响乐团的演出。本场演出获得了钢琴家王羽佳的倾情加盟，演出门票一售而空。这场精彩的演出也收获了包括 <a target="_blank" href="https://www.nytimes.com/2017/07/23/arts/music/review-us-youth-orchestra-inspires-a-chinese-counterpart.html">《纽约时报》</a> 等海内外刊物的广泛好评。NYO-China受卡内基音乐厅NYO-USA（美国国家青少年交响乐团）启发而诞生。在由美国国务卿约翰·克里和中国国务院副总理刘延东共同主持的“第五轮中美人文交流高层磋商”上，NYO-USA被确立为“文化支柱”项目。',
          'containsHTML': 'true',
        },
        {
          'text':'NYO-China不向学生收取任何费用；项目承担入选成员的学费、交通费和饮食住宿费等，确保勤奋、有天赋的音乐家不会因为经费问题而错失展示才华的机会。',
          'containsHTML': 'false',
        }
      ]
    },

    'endorsements' : {
      'title' : '各界支持',
      'endorsement_list' : [
        {
          'imgSrc' : '/img/about/endorsers/robert-blocker.jpg',
          'name' : '罗伯特·布洛克尔',
          'title' : '耶鲁大学亨利和露西摩西音乐学院院长',
          'text' : '“这些年轻的音乐家将在世界上最负盛名的音乐厅演出，他们将与全球最著名的音乐家合作，共同演奏音乐。对他们而言，这将是一次变革式的体验。”',
        },
        {
          'imgSrc' : '/img/about/endorsers/clive-gillinson.jpg',
          'name' : '克莱夫·基林森爵士',
          'title' : '卡内基音乐厅执行和艺术总监',
          'text' : '“音乐在中国的发展是令人惊叹的。中国将扮演 ‘定义’ 21世纪音乐的重要角色。就此而言，中华青少年交响乐团是一座引领卓越的灯塔，让人心生向往。”',
        },
        {
          'imgSrc' : '/img/about/endorsers/gary-graffman.jpg',
          'name' : '加里·格拉夫曼',
          'title' : '柯蒂斯音乐学院荣誉校长',
          'text' : ' “当我在柯蒂斯听到极具天赋的年轻音乐家演奏时，我听到了古典乐充满光明的未来。NYO-China将让世界各地观众知道，这些中国音乐家将是古典乐的未来。”',
        },
        {
          'imgSrc' : '/img/about/endorsers/yue-sai-kan.jpg',
          'name' : '靳羽西',
          'title' : '艾美奖获奖电视制片人、企业家',
          'text' : '“一次又一次，音乐超越文字，为沟通架起了一座座桥梁。这些学生和这支乐团将以促进文化和对外交流为使命，开启一场充满朝气的旅程。”',
        },
        {
          'imgSrc' : '/img/about/endorsers/gary-locke.jpg',
          'name' : '骆家辉',
          'title' : '前美国驻华大使、华盛顿州州长',
          'text' : '“中华青少年交响乐团用‘音乐’这一共同语言将人们汇聚在一起。它将打破国家的边界，促进彼此之间对文化和历史的理解。”',
        },
        {
          'imgSrc' : '/img/about/endorsers/ron-losby.jpg',
          'name' : '罗恩·罗斯彼',
          'title' : '施坦威钢琴公司首席执行官',
          'text' : '“中华青少年交响乐团为学生带来了一个巨大的平台，让他们有机会在更多观众面前展示自己努力练习的成果。这段演出经历将在未来多年一直陪伴他们。”',
        },
        {
          'imgSrc' : '/img/about/endorsers/chien-chung-pei.jpg',
          'name' : '贝建中',
          'title' : '华美协进社董事会主席',
          'text' : '“音乐是可以融进你血液的东西，是你无法除去的部分！对于中国年轻的艺术家，这个交响乐团将是一个绝佳的机会，拓展你对音乐的全新认知。”',
        },
        {
          'imgSrc' : '/img/about/endorsers/tan-dun.jpg',
          'name' : '谭盾',
          'title' : '奥斯卡获奖作曲家、NYO-USA委约作曲家',
          'text' : '“为年轻的乐团创作、和年轻人一起表演是我锻炼自己的最好方式。这些年轻的音乐家总能激发我的灵感，让我不断学习、获得启发。”',
        },
        {
          'imgSrc' : '/img/about/endorsers/ye-xiaogang.jpg',
          'name' : '叶小钢',
          'title' : '著名作曲家、中国音乐家协会主席',
          'text' : '“这些年轻的艺术家用他们精湛的音乐技能和深厚的艺术修养征服了世界！他们开创了一项中美文化界和艺术界的盛事。”',
        },
        {
          'imgSrc' : '/img/about/endorsers/zhang-qiyue.jpg',
          'name' : '章启月',
          'title' : '中国驻纽约总领事馆大使兼总领事',
          'text' : '“NYO-China为中美两国年轻的艺术人才提供了相互交流、建立友谊的机会。这将为加强中美两国之间的友好关系打下坚实基础。”',
        }
      ]
    },
    'location' : {
      'title' : '公司地址',
      'address' : {
        'line1' : '810 Seventh Avenue, Suite 2000',
        'line2' : 'New York, New York 10019',
        'line3' : 'United States',
      },
      'coords' : {
        'lat' : 40.762873,
        'lng' : -73.982590,
      }
    },

    'contact' : {
      'title' : '联系我们',
      'instruction' : '您可以通过填写表单联系我们。',
      'methods' : [
        {
          'text':'总问询',
          'isLink': false,
        },
        {
          'text':'english@nyochina.org',
          'isLink': true,
        },
        {
          'text':'chinese@nyochina.org',
          'isLink': true,
        },
        {
          'text':'李文森',
          'isLink': true,
        },
        {
          'text':'执行总监',
          'isLink': false,
        },
        {
          'text':'vincent.accettola@nyochina.org',
          'isLink': true,
        },
        {
          'text':'尼古拉斯·布朗',
          'isLink': false,
        },
        {
          'text':'开发总监',
          'isLink': false,
        },
        {
          'text':'nicholas.brown@nyochina.org',
          'isLink': true,
        },
        {
          'text':'钟珣',
          'isLink': false,
        },
        {
          'text':'传播总监',
          'isLink': false,
        },
        {
          'text':'peggie.zhong@nyochina.org',
          'isLink': true,
        }
      ],
      'form' : {
        'submit' : '确认提交',
        'name' : '姓名',
        'firstName' : '名',
        'lastName' : '姓',
        'email' : '电子邮箱',
        'subject' : '主题',
        'message' : '内容',
        'submissionMessage' : '感谢提交!',
        'invalidFormMsgTop' : '您的表格出问题啦！请再次检查您填写的内容。',
        'invalidFormMsgBottom' : '您的表格出问题啦！请再次检查您填写的内容。',
        'missingFirstAndLastNameMsg' : '姓名必填',
        'missingFirstNameMsg' : '必填姓名不完整: 名',
        'missingLastNameMsg' : '必填姓名不完整: 姓',
        'missingEmailMsg' : '电子邮箱必填',
        'invalidEmailMsg' : '电子邮箱无效。邮箱地址格式必须为user@domain.com。',
        'missingSubjectMsg' : '主题必填',
        'missingMessageMsg' : '内容必填',
      }
    }

  },
  'inaugural_season_page' : {
    overview : {
      title : '2017 首届中华青少年交响乐团',
      imgSrc : '/img/inaugural_season/carnegie_concerto.jpg',
      description : [
        {
          'text':'中华青少年交响乐团（NYO-China）于2017年正式创办，旨在为中国杰出的青少年音乐家提供世界级的音乐指导和演出机会，进而培养他们成为世界舞台上展示中国风采的新一代艺术使者。首届NYO-China由105名来自中国各地的年轻音乐家组成，他们从上千名14至21岁的申请者中脱颖而出。NYO-China全程承担所有入选成员的学费、交通费和住宿费，确保勤奋、有天赋的音乐家不会因为经费问题而错失展示才华的机会。',
          'containsHTML': 'false',
        },
        {
          'text':'2017年夏，这些年轻的演奏家们在美国进行了两周严格的封闭式训练。他们跟随世界顶尖的音乐家学习，全力以赴筹备中美两地音乐会巡演。其中卡内基音乐厅全球首演获得巨大成功，为巡演拉开了完美的序幕。',
          'containsHTML': 'false',
        },
      ]
    },
    overview_blocks : [
      {
        title : '住宿制音乐训练营',
        imgSrc : '/img/inaugural_season/training_residency.jpg',
        description : [
          {
            'text':'NYO-China住宿制训练营在东斯特劳斯堡大学（East Stroudsburg University of Pennsylvania，简称ESU）开展。ESU校区位于风景壮丽的波科诺地区，距纽约仅1.5小时车程。NYO-China学员们跟随一众世界知名音乐导师，在ESU进行集体排练、分部排练、大师班和一对一教学等课程。此外，学员还参与了由茱莉亚学院老师Lori Schiff指导的亚历山大技巧互动课（Alexander Technique）、由Eugene Frisen开展的即兴演奏课、室内乐演奏等课程。两周的训练营不仅让学员为中美两地的巡演做好了充分准备，也给学员们指引了通往专业音乐演奏家之路的未来。',
            'containsHTML': 'false',
          }
        ]
      },
      {
        title : '中美NYO联合彩排',
        imgSrc : '/img/inaugural_season/joint_rehearsal.jpg',
        description : [
          {
            'text':'7月16日， NYO-China与美国国家青少年交响乐团（NYO-USA）在纽约州立大学帕切斯分校举办了一场特别的文化交流活动。两支乐团成员在指挥路多维克·莫洛（西雅图交响乐团音乐总监兼2017届NYO-China特邀指挥）、詹姆斯·罗斯（NYO-USA乐团总监）及蔡金冬（NYO-China艺术总监）三位艺术家的指挥下开展了一场别开生面的联合彩排。来自中美两国的小音乐家们用音乐打破了文化、政治、语言的隔阂，相互交流学习音乐的体会和感悟。彩排结束一周后，两支乐团分别出席了各自在卡内基音乐厅的首演，学员们互相见证了彼此努力训练的成果。',
            'containsHTML': 'false',
          }
        ]
      },
      {
        title : '卡内基音乐厅首演',
        imgSrc : '/img/inaugural_season/carnegie_debut.jpg',
        description : [
          {
            'text':'NYO-China于2017年7月22日晚在卡内基音乐厅拉开首演帷幕。在指挥莫洛和钢琴家王羽佳的带领下，乐团演奏了三首正式曲目，包括普利策获奖作曲家周龙的《鼓韵》、柴可夫斯基《降B小调第一钢琴协奏曲》以及德沃夏克《E小调第九交响曲“自新大陆”》（一般称为《新世界交响曲》）。此外，王羽佳加演了霍洛维茨《卡门主题变奏曲》作为返场独奏曲目。演出当天，2804座的斯特恩礼堂座无虚席，同时演出在全球范围进行了直播。此次演出获得了极大的成功，《纽约时报》评论 <em> <a target="_blank"  href="https://www.nytimes.com/2017/07/23/arts/music/review-us-youth-orchestra-inspires-a-chinese-counterpart.html"> “如果（卡内基演出）是给这支新乐团的一场考试，那么这些中国音乐家高分通过。" </a> </em>',
            'containsHTML': 'true',
          }
        ]
      },
      {
        title : '中国音乐会巡演',
        imgSrc : '/img/inaugural_season/concert_tour.jpg',
        description : [
          {
            'text':'NYO-China中国巡演在国内顶尖音乐厅举行，演出地点包括北京音乐厅、上海东方艺术中心及苏州大剧院，共计5000余位观众出席音乐会。俄罗斯裔钢琴家奥尔加·科恩的倾情加盟三地巡演，延续了卡内基音乐厅首演的成功，给包括学生亲友在内的中国当地观众带来了精彩纷呈的演出。在团长叶小钢的带领下，乐团在三座城市引起了古典乐爱好者热烈的反响。叶团长编曲的《旱天雷》作为返场曲目在包括卡内基在内的巡演音乐厅奏响，此曲深受各地观众喜爱。在一周的巡演结束后，乐团成员带着回忆返回自己的家乡，而NYO-China带给他们的收获将一直伴随他们成长。',
            'containsHTML': 'false',
          }
        ]
      }
    ],
    featured_artists : {
      title : '特邀艺术家',
      artists : [
        {
          title : '路多维克·莫洛',
          imgSrc : '/img/inaugural_season/ludovic_morlot.png',
          description : [
            {
              'text':'路多维克·莫洛是新一代指挥家中冉冉升起的一颗璀璨之星。他是西雅图交响乐团首席指挥，同时担任波士顿、纽约、芝加哥、洛杉矶等地交响乐团的常任客座指挥。在西雅图交响乐团任职期间，他凭借指挥小提琴家奥古斯汀·哈德西里（Augustin Hadelich）与西雅图交响乐团演奏杜提耶小提琴协奏曲，获得2016格莱美年度“最佳古典器乐独奏”奖。2002至2004年，他曾指挥里昂国家交响乐团（Orchestre National de Lyon）, 并同时监管两支ONL青少年交响乐团，他在与青少年音乐家合作方面经验丰富。此外，他还担任华盛顿大学管弦乐团指挥系主任。',
              'containsHTML': 'false',
            }
          ]
        },
        {
          title : '王羽佳',
          imgSrc : '/img/inaugural_season/yuja_wang.jpg',
          description : [
            {
              'text':'王羽佳是当今世界最炙手可热的钢琴家之一，《美国音乐年鉴》（Musical America） 2017年度艺术家。出生于北京的王羽佳自6岁起学习钢琴，一年后便进入中央音乐学院附中进修。2001年，她成为施坦威艺术家（Steinway Artist）；2002年，她被费城柯蒂斯音乐学院录取，跟随大师加里·格拉夫曼（Gary Graffman）学习。她曾荣获多项艺术大奖，其中包括2006年吉尔莫年轻艺术家奖(Gilmore Young Artist Award)；2009年古典音乐留声机杂志（Gramophone Classic FM） 年度“青年艺术家”奖；2011年古典回声奖（Echo Klassik）年度“青年艺术家”奖。',
              'containsHTML': 'false',
            }
          ]
        },
        {
          title : '奥尔加·科恩',
          imgSrc : '/img/inaugural_season/olga_kern.jpg',
          description : [
            {
              'text':'奥尔加·科恩是国际知名俄罗斯裔钢琴家、施坦威艺术家。她在多项国际比赛中摘得桂冠，成为同辈钢琴家中的佼佼者。17岁时，她获得拉赫玛尼国际钢琴比赛冠军。2001年，她一举获得第11届范·克莱本国际钢琴大赛金奖，成为过去30年中该项比赛唯一一位获此殊荣的女钢琴家。她的唱片包括获格莱美奖提名的拉赫玛尼诺夫《科莱利主题变奏曲》（2004），《勃拉姆斯变奏曲》（2007）和《肖邦第二、第三钢琴奏鸣曲》（2010）等。2016年，她出任第七届范·克莱本国际业余钢琴大赛评委，并在首届奥尔加·科恩国家钢琴大赛中担任艺术总监和评委。',
              'containsHTML': 'false',
            }
          ]
        },
      ]
    },
    teaching_artists : {
      title : '音乐导师',
      artists: [
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/jindong_cai.jpg',
          href : 'https://sso.stanford.edu/conductors/',
          'name' : '蔡金冬',
          'position' : '艺术总监',
          'affiliation' : '斯坦福大学',
          'affiliate_position' : '演奏系教授'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/frank_huang.jpg',
          href : 'https://nyphil.org/about-us/artists/frank-huang',
          'name' : '黄欣',
          'position' : '第一小提琴',
          'affiliation' : '纽约爱乐乐团',
          'affiliate_position' : '乐团首席'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/qing_li.jpg',
          href : 'https://www.bsomusic.org/musicians/musician/qing-li/',
          'name' : '李青',
          'position' : '第二小提琴',
          'affiliation' : '巴尔的摩交响乐团',
          'affiliate_position' : '第二提琴首席'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/jay_liu.jpg',
          href : 'https://www.sfsymphony.org/About-Us/Musicians-Conductors/Members-Of-Orchestra/Viola#artist-4197',
          'name' : '刘韵杰',
          'position' : '中提琴',
          'affiliation' : '旧金山交响乐团',
          'affiliate_position' : '中提琴副首席'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/qiang_tu.jpg',
          href : 'https://nyphil.org/about-us/artists/qiang-tu',
          'name' : '涂强',
          'position' : '大提琴',
          'affiliation' : '纽约爱乐乐团',
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/daxun_zhang.jpg',
          href : 'http://www.daxunzhang.com/',
          'name' : '张达寻',
          'position' : '低音提琴',
          'affiliation' : '德克萨斯大学',
          'affiliate_position' : '低音提琴教授'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/sibei_weng.jpg',
          href : 'http://www.om-macau.org/en/artist/weng-sibei/',
          'name' : '翁斯贝',
          'position' : '长笛',
          'affiliation' : '澳门乐团',
          'affiliate_position' : '长笛首席'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/yaoguang_zhai.jpg',
          href : 'http://www.yaoclarinet.com/',
          'name' : '翟耀光',
          'position' : '单簧管',
          'affiliation' : '巴尔的摩交响乐团',
          'affiliate_position' : '单簧管首席'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/liang_wang.jpg',
          href : 'https://nyphil.org/about-us/artists/liang-wang',
          'name' : '王亮',
          'position' : '双簧管',
          'affiliation' : '纽约爱乐乐团',
          'affiliate_position' : '双簧管首席'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/fei_xie.jpg',
          href : 'https://www.bsomusic.org/musicians/musician/fei-xie/',
          'name' : '谢非',
          'position' : '巴松管',
          'affiliation' : '巴尔的摩交响乐团',
          'affiliate_position' : '巴松管首席'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/xiaoming_han.jpg',
          href : 'http://www.drp-orchester.de/drp/orchester/musiker/musiker-han_xiao-ming100.html',
          'name' : '韩小明',
          'position' : '圆号',
          'affiliation' : '德国广播交响乐团',
          'affiliate_position' : '圆号首席'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/guang_chen.jpg',
          href : 'http://www.ccom-prep.org/ENG/contents/jxtd/CHENGUANG.html',
          'name' : '陈光',
          'position' : '小号',
          'affiliation' : '中央音乐学院',
          'affiliate_position' : '小号教授'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/wei_zhu.jpg',
          href : 'http://www.bremerphilharmoniker.de/index.php/Orchester/musiker.html',
          'name' : '朱玮',
          'position' : '长号',
          'affiliation' : '不来梅交响乐团',
          'affiliate_position' : '长号首席'
        },
        {
          isClickable : false,
          imgSrc : '/img/inaugural_season/haiyu_wang.jpg',
          'name' : '王海宇',
          'position' : '大号',
          'affiliation' : '印第安纳大学雅各布音乐学院',
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/gert_mortensen.jpg',
          href : 'http://www.gertmortensen.com/',
          'name' : '莫徒生',
          'position' : '打击乐器',
          'affiliation' : '荷兰皇家管弦乐团',
          'affiliate_position' : '打击乐教授'
        },
        {
          isClickable : true,
          imgSrc : '/img/inaugural_season/jieyin_wu.jpg',
          href : 'http://jieyinwu.com/',
          'name' : '吴捷音',
          'position' : '竖琴',
          'affiliation' : '竖琴演奏家',
        },
      ]
    },
    class_of_2017 : {
      title : '2017 届乐团成员',
      imgSrc : '/img/inaugural_season/class_of_2017.jpg',
      description : [
        {
          'text':'经过严格的选拔过程，首届NYO-China的105名成员从近千名申请者中脱颖而出。他们来自中国23个省级行政区，部分现在海外学习或居住；根据要求，入选成员均为中国籍公民。这些年轻的音乐家们来自全球各地38所音乐院校或普通高校，其中包括中央音乐学院、上海音乐学院、中国音乐学院、星海音乐学院、北京大学；以及茱莉亚学院、新英格兰音乐学院、克利夫兰音乐学院等海外院校。他们是中国年轻一代音乐人才的杰出代表。',
          'containsHTML': 'false',
        },
      ]
    },
    link_to_website : {
      href : "https://2017.nyochina.org",
      text : '更多2017届成员信息请访问NYO-CHINA网站'
    },
  },
  chamber_series_page : {
    overview : {
      title : '2018 室内乐系列',
      imgSrc : '/img/chamber_series/yale_performance.jpg',
      description : [
        {
          'text':'2018年，中华青少年交响乐团再次启动。今年夏天，NYO-China将开展室内乐系列，该项目围绕室内乐演奏进行，由住宿制训练营和音乐会巡演两大部分组成。本届NYO-China将录取10到15位年龄在14至21岁之间的音乐家(或22岁以下的NYO-China往届生)。他们将在7月齐聚北京中央音乐学院，在世界一流的艺术家导师指导下，排练多首精彩的室内乐作品。随后，学生和导师将共同踏上巡演之旅，同台展示他们的训练成果，并参加多项文化交流活动和演出。',
          'containsHTML': 'false',
        },
        {
          'text':'NYO-China 旨在通过2018年精品室内乐项目为学员提供更有针对性的音乐培训和演出机会。培训期间，他们将有更多机会接受导师一对一的指导，并且有更充裕的时间与志同道合的朋友进行排练。训练结束后，室内乐团将通过丰富的巡演机会与各地观众进行互动交流。这段经历将带领乐团成员探索在创造音乐过程中所需的诚恳及开放的心态，并让他们体会保持这样心态所带来的积极力量。',
          'containsHTML': 'false',
        },
        {
          'text':'与NYO-China其他活动相同，项目将承担学生的所有费用，包括学费、饮食、住宿和国内交通等，确保勤奋、有天赋的音乐家不会因为经费问题而错失展示才华的机会。',
          'containsHTML': 'false',
        },
      ]
    },
    overview_blocks : [
      {
        title : '住宿制训练营',
        description : [
          {
            'text':'7月15日至28日， NYO-China室内乐系列将于中央音乐学院开展封闭式训练，训练持续2周。届时，10到15名年轻音乐家将接受艺术家导师具有针对性的室内乐训练。除日常室内乐分组排练外，学生还将参加大师班，音乐理论、即兴演出等讲座，以及一对一课程。',
            'containsHTML': 'false',
          }
        ]
      },
      {
        title : '音乐会巡演',
        description : [
          {
            'text':'7月29日至8月4日，学生与导师将共同踏上巡演之旅，在国内一流的音乐厅拉开室内乐演奏会的帷幕。首场音乐会将于中央音乐学院歌剧音乐厅举行。巡演期间，他们还将参加青岛西海岸音乐季开幕式演出，并有机会与来自美国国家青少年交响乐团(NYO-USA)的学生进行文化交流活动。',
            'containsHTML': 'false',
          }
        ]
      },
    ],
    teaching_artists : {
      title : '艺术家导师',
      artists : [
        {
          title : '李青，弦乐导师',
          description : [
            {
              'text':'李青，巴尔的摩交响乐团的二提琴首席，美国皮博蒂音乐学院小提琴教授。她是一位以交响乐团首席小提琴演奏家，室内乐演奏家及独奏家身份活跃在美国及国际舞台上的华裔音乐家。李青才华横溢， 演奏的作品令人惊艳，她的音乐处理在保持静谧风格的同时，投入了其无尽的热情和独特的见解。一直以来，李青受到观众及音乐评论家的好评，《巴尔的摩太阳报》将她誉为“具有强烈内在激情”， “拥有无可比拟的辉煌技巧” 及 “演奏风格无可挑剔”的小提琴演奏家。李青出生于中国北京，四岁时开始和父亲一起学习小提琴。12岁时，李青考入中央音乐学院。美国著名小提琴家Berl Senofsky来华举办大师班时发现了她的音乐才华，即邀请她以全额奖学金的身份赴美国深造。现在她的爱琴是1736年意大利小提琴名匠尼古拉·加里亚诺(Nicolo Gagliano)大师的作品。',
              'containsHTML': 'false',
            }
          ]
        },
        {
          title : '马勇，木管导师',
          description : [
            {
              'text':'马勇，中央歌剧院首席长笛，深圳交响乐团客座首席长笛。他在卡内基音乐厅的首演被纽约音乐会评论(New York Concert Review)赞为“其技能之纯熟无可挑剔” ，“对作品的诠释达到了出神入化的境界”。马勇自8岁时起学习长笛，1993年考入中央音乐学院，师从王永新教授。13岁就在“捷克布拉格之春国际音乐比赛”中获得优异的成绩。1998年，马勇被茱莉亚音乐学院以全额奖学金录取，以优秀成绩获得学士学位和硕士学位。在茱莉亚期间，他师从世界著名的长笛演奏家Carol Wincenc以及纽约爱乐乐团的首席长笛Robert Langevin。马勇曾担任深圳交响乐团和美国路易斯维尔交响乐团的首席长笛。此外，他也是首位以客座首席身份与纽约爱乐乐团，马来西亚交响乐团，巴尔第摩交响乐团和茱莉亚交响乐团合作的华裔长笛家。马勇现担任山西中北大学及吉林艺术学院客座教授。',
              'containsHTML': 'false',
            }
          ]
        },
        {
          title : '陈光，铜管导师',
          description : [
            {
              'text':'陈光，中央音乐学院管弦系小号教授，乐队学院行政总监，中国国家交响乐团客座首席小号。自幼学习小号专业，1997年以优异成绩考入中央音乐学院，师从冀瑞铠教授。1999年获组宾·梅塔奖学金，前往维也纳国立音乐与表演艺术大学继续深造。在维也纳期间师从Josef Pomberger教授、Adolf Holler教授。自那时起，陈光与维也纳国家歌剧院、维也纳室内乐团以及维也纳施特劳斯乐团合作演出。自2005年毕业于维也纳以来，陈光曾多次担任世界著名乐团的客座首席，包括中国爱乐乐团、中国国家芭蕾舞团以及全国各大交响乐团。2008年7月至2012年7月，陈光应邀担任亚洲爱乐交响乐团的首席小号演奏家，并参加乐团的亚洲巡演。2011年，他受马来西亚爱乐乐团邀请担任首席小号演奏家。2012年至2014年，他在新加坡交响乐团担任首席小号，并参加乐团演出季及录音。',
              'containsHTML': 'false',
            }
          ]
        },
      ]
    },
    student_artists : {
      title : '2018届成员名单',
      artists: [
        {
          isClickable : false,
          'name' : '曹宇博',
          'position' : '小提琴',
          'affiliation' : '中央音乐学院附中',
        },
        {
          isClickable : false,
          'name' : '傅怡青',
          'position' : '小提琴',
          'affiliation' : '约翰霍普金斯皮博迪音乐学院',
        },
        {
          isClickable : false,
          'name' : '李函珂',
          'position' : '小提琴',
          'affiliation' : '中央音乐学院附中',
        },
        {
          isClickable : false,
          'name' : '王一翔',
          'position' : '小提琴',
          'affiliation' : '上海音乐学院附中',
        },
        {
          isClickable : false,
          'name' : '李俊逸',
          'position' : '中提琴',
          'affiliation' : '星海音乐学校附属中学',
        },
        {
          isClickable : false,
          'name' : '曾妤婕',
          'position' : '中提琴',
          'affiliation' : '上海音乐学院附中',
        },
        {
          isClickable : false,
          'name' : '李志弘',
          'position' : '大提琴',
          'affiliation' : '美国曼尼斯音乐学院',
        },
        {
          isClickable : false,
          'name' : '朱天橙',
          'position' : '大提琴',
          'affiliation' : '加拿大麦克奈尔中学',
        },
        {
          isClickable : false,
          'name' : '党雅馨',
          'position' : '长笛',
          'affiliation' : '武汉音乐学院',
        },
        {
          isClickable : false,
          'name' : '谢子舒',
          'position' : '长笛',
          'affiliation' : '欧柏林音乐学院',
        },
        {
          isClickable : false,
          'name' : '张宁',
          'position' : '单簧管',
          'affiliation' : '茱莉亚音乐学院',
        },
        {
          isClickable : false,
          'name' : '邹汇斌',
          'position' : '单簧管',
          'affiliation' : '克利夫兰音乐学院',
        },
        {
          isClickable : false,
          'name' : '程景仁',
          'position' : '双簧管',
          'affiliation' : '中央音乐学院附中',
        },
        {
          isClickable : false,
          'name' : '汪一川',
          'position' : '双簧管',
          'affiliation' : '中央音乐学院附中',
        },
        {
          isClickable : false,
          'name' : '王婧琰',
          'position' : '巴松',
          'affiliation' : '中央音乐学院附中',
        },
        {
          isClickable : false,
          'name' : '龚一诚',
          'position' : '圆号',
          'affiliation' : '上海音乐学院附中',
        },
        {
          isClickable : false,
          'name' : '张济涵',
          'position' : '圆号',
          'affiliation' : '山东省济南第十三中学',
        },
        {
          isClickable : false,
          'name' : '刘兆庭',
          'position' : '小号',
          'affiliation' : '北京市八一学校',
        },
        {
          isClickable : false,
          'name' : '吴天骐',
          'position' : '小号',
          'affiliation' : '四川音乐学院',
        },
        {
          isClickable : false,
          'name' : '陈朴元',
          'position' : '长号',
          'affiliation' : '曼哈顿音乐学院',
        },
        {
          isClickable : false,
          'name' : '周棣',
          'position' : '大号',
          'affiliation' : '深圳市龙华中学',
        },
      ]
    },
    auditions : {
      title: '试听选拔',
      description : [
        {
          'text':'2018届NYO-China试听选拔将在线进行。项目期间年龄在14至21周岁的中国公民(包括香港和澳门)均有资格申请；参与过2017届NYO-China的学生无论年龄，均有资格申请。因为今年项目将围绕室内乐开展，我们只接受以下乐器的申请：小提琴、中提琴、大提琴、长笛、单簧管、双簧管、巴松管、小号、圆号、长号和大号。',
          'containsHTML': 'false',
        },
        {
          'text':'申请材料包括1) 报名申请表; 2) 身份证正面或护照首页扫描件；3) 演奏视频：1首独奏曲目及2-3首指定考试曲目(详见下文要求)；4) 欢迎发送额外的申请材料如简历，但非必须。',
          'containsHTML': 'true',
        },
        {
          'text' : '请将完整的申请材料发送至auditions@nyochina .org，并以“姓名+乐器+学校”命名。请在中国时间6月10日(周日)晚11:59前提交。提交材料后，你将收到确认邮件。招生将采取滚动形式，我们鼓励学生尽早申请。申请将由本季的艺术家导师审核，所有结果预计将于六月底前公布。',
          'containsHTML': 'false',
        }
      ],
      application_form : {
        href : "/img/auditions/application_form.pdf",
        text : '下载申请表格'
      },
      excerpts : {
        title : '演奏视频要求',
        description : [
          {
            'text' : '演奏视频包括：1) 1首自选乐段(长度为2-4分钟)；2) 2-3首指定考试曲目选段(下载链接如下所示，如无法下载请邮件<a target="_blank" href="mailto:auditions@nyochina.org">auditions@nyochina.org</a>获取材料)。',
            'containsHTML' : 'false',
          },
          {
            'text' : '您的演奏视频应录制于六个月以内，并完整显示您的脸部；所有视频应是未经剪辑的。请将视频按照演奏内容命名，并上传到腾讯、优酷、土豆等视频网站，请以链接的形式发送，不接受超过50M超大附件下载。',
            'containsHTML' : 'false',
          },
          {
            'text' : '如有任何问题，请及时邮件咨询NYO-China团队。我们期待你的申请！',
            'containsHTML' : 'false',
          },
        ],
        excerpts : [
          {
            href : "/img/auditions/violin.pdf",
            text : '小提琴'
          },
          {
            href : "/img/auditions/viola.pdf",
            text : '中提琴'
          },
          {
            href : "/img/auditions/cello.pdf",
            text : '大提琴'
          },
          {
            href : "/img/auditions/flute.pdf",
            text : '长笛'
          },
          {
            href : "/img/auditions/clarinet.pdf",
            text : '单簧管'
          },
          {
            href : "/img/auditions/oboe.pdf",
            text : '双簧管'
          },
          {
            href : "/img/auditions/bassoon.pdf",
            text : '巴松管'
          },
          {
            href : "/img/auditions/horn.pdf",
            text : '圆号'
          },
          {
            href : "/img/auditions/trumpet.pdf",
            text : '小号'
          },
          {
            href : "/img/auditions/trombone.pdf",
            text : '长号'
          },
          {
            href : "/img/auditions/tuba.pdf",
            text : '大号'
          }
        ]
      }
    },
    signup : {
      instruction : 'More details about the faculty, residency, concert tour, and admissions process will be released soon.',
      form : {
        submissionMessage : 'Thank You!',
        title : 'Learn More',
        instruction : 'Sign up to be notified once more information becomes available.',
        firstName : 'First Name',
        lastName : 'Last Name',
        email : 'Email Address',
        submit : 'SIGN UP',
        'missingFirstAndLastNameMsg' : 'Name is required.',
        'missingFirstNameMsg' : 'Name is missing required subfields: First',
        'missingLastNameMsg' : 'Name is missing required subfields: Last',
        'missingEmailMsg' : 'Email Address is required',
        'invalidEmailMsg' : 'Email Address is not valid. Email addresses should follow the format user@domain.com.',
      }
    },
  },
  press_media_page : {
    featured_articles : {
      title : '推荐文章',
      articles: [
        {
          isLink : true,
          href : 'https://www.nytimes.com/2017/07/18/arts/music/in-these-national-orchestras-of-china-and-united-states-youth-meets-musical-beauty.html',
          imgSrc : '/img/media/articles/youth.png',
          title : '音乐在乐声中飞扬（2017年7月18日）',
          description : [
            {
              containsHTML : true,
              text : '作者:《纽约时报》 资深乐评人 James R. Oestreich',
            }
          ]
        },
        {
          isLink : true,
          href : 'https://www.nytimes.com/2017/07/23/arts/music/review-us-youth-orchestra-inspires-a-chinese-counterpart.html',
          imgSrc : '/img/media/articles/counterpart.png',
          title : '乐评：这场考试他们以高分通过（2017年7月23日）',
          description : [
            {
              containsHTML : true,
              text : '作者:《纽约时报》 首席乐评人 Anthony Tommasini',
            }
          ]
        },
        {
          isLink : true,
          href : 'https://www.steinway.com/news/features/china-nyo',
          title : '动人音符打破文化隔阂（2017年7月27日）',
          description : [
            {
              containsHTML : true,
              text : 'By Kelly Kollias, <em>《施坦威杂志》 </em>',
            }
          ]
        },
        {
          isLink : true,
          href : 'http://usa.chinadaily.com.cn/epaper/2017-07/28/content_30280812.htm',
          title : '勤奋，成就中华青少年传奇（2017年7月28日）',
          description : [
            {
              containsHTML : true,
              text : 'By 肖宏, <em>《中国日报》</em>',
            }
          ]
        },
        {
          isLink : true,
          href : 'https://www.fromthetop.org/musician/national-youth-orchestra-china/',
          title : '美国国家公共广播NPR From the Top专访：中华青少年交响乐团（2017年7月）',
          description : []
        },
        {
          isLink : true,
          href : 'https://www.wqxr.org/story/national-youth-orchestra-china/',
          title : 'WQXR电台年轻艺术家展示：NYO-China（2017年7月）',
          description : []
        },
      ]
    },
    journals : {
      title : '刊物',
      journals : [
        {
          isLink: true,
          href : 'https://issuu.com/nyochina/docs/nyo-china-2017-journal-chinese',
          src : '/img/2017_journal_cn.png',
        },
        {
          isLink: true,
          href : 'https://issuu.com/nyochina/docs/nyo-china-class-of-2017-chinese',
          src : '/img/2017_class_book_cn.png',
        },
        {
          isLink: true,
          href : 'https://issuu.com/nyochina/docs/2018_journal__chinese_',
          src : '/img/2018_journal.png',
        }
      ],
    },
    support_letters : {
      title : '支持信函',
      letters: [
        {
          imgSrc: '/img/media/letters/cuomo.jpg',
          description: [
            {
              containsHTML: false,
              text : '安德鲁科莫 - 纽约州州长',
            }
          ]
        },
        {
          imgSrc: '/img/media/letters/de_blasio.jpg',
          description: [
            {
              containsHTML: false,
              text : '比尔·德·布拉西奥 - 纽约市市长',
            }
          ]
        },
        {
          imgSrc: '/img/media/letters/locke.jpeg',
          description: [
            {
              containsHTML: false,
              text : '骆家辉 - 前美国驻华大使, 华盛顿州州长',
            }
          ]
        },
        {
          imgSrc: '/img/media/letters/qiyue_zhang.jpg',
          description: [
            {
              containsHTML: false,
              text : '章启月 - 中国驻纽约总领事馆大使兼总领事',
            }
          ]
        }
      ]
    },
    videos : {
      title : '视频库',
      videos : [
        {
          src : "https://v.qq.com/iframe/player.html?vid=n0682z040f8&tiny=0&auto=0",
        },
        {
          src : "https://v.qq.com/iframe/player.html?vid=e0714ul79p0&tiny=0&auto=0",
        },
        {
          src : "https://v.qq.com/iframe/player.html?vid=s0716q240dc&tiny=0&auto=0",
        }
      ]
    },
    link_to_videos : {
      text : '查看其他视频',
      href : "https://vimeo.com/user21234279",
    },
    photo_gallery : {
      title : '照片墙',
      photos : [
        '/img/media/photos/1.jpg',
        '/img/media/photos/2.jpg',
        '/img/media/photos/3.jpg',
        '/img/media/photos/4.jpg',
        '/img/media/photos/5.jpg',
        '/img/media/photos/6.jpg',
        '/img/media/photos/7.jpg',
        '/img/media/photos/8.jpg',
        '/img/media/photos/9.jpg',
        '/img/media/photos/10.jpg',
        '/img/media/photos/11.jpg',
        '/img/media/photos/12.jpg',
        '/img/media/photos/13.jpg',
        '/img/media/photos/14.jpg',
        '/img/media/photos/15.jpg',
        '/img/media/photos/16.jpg',
        '/img/media/photos/17.jpg',
        '/img/media/photos/18.jpg',
        '/img/media/photos/19.jpg',
        '/img/media/photos/20.jpg',
        '/img/media/photos/21.jpg',
        '/img/media/photos/22.jpg',
        '/img/media/photos/23.jpg',
        '/img/media/photos/24.jpg',
      ],
    }
  },
  'footer' : {
    'copyright' : 'Copyright © 2017 NYO-China. All rights reserved.',
  }
}



// WEBPACK FOOTER //
// ./src/data-cn.js